import { createContext, useContext } from 'react'

// Separate context for the user/contact search domain (Repo Invitation modal).
// Kept distinct from SearchContext to avoid coupling the two independent search trees.

const defaultValue = {
  suggestions: [], // user hits from GET /search/users
  currentRefinement: '', // current query string
  refine: () => {}, // update query
}

export const UserSearchContext = createContext(defaultValue)

export function useUserSearchContext() {
  return useContext(UserSearchContext)
}
